import axios from '@/utils/request.js'

export const getCompanyUserList = params => {
  // 获取首页数据
  return axios.post('/goods/gas/company/getCompanyCusInfo', params)
}

export const getUserdetail = id => {
  // 查询用户详细信息
  return axios.get(`/goods/bGlmCustomer/detail/${id}`)
}
export const updateWeightById = params => {
  // 修改日使用量
  return axios.post('/goods/bGlmCustomer/updateWeightById ', params)
}
